export default {
  'team.title': 'Rencontrez notre équipe',
  'team.subtitle': 'Notre équipe diversifiée d\'experts rassemble des décennies d\'expérience en technologie, finance et investissements stratégiques pour stimuler l\'innovation et la croissance.',
  
  'team.roger.name': 'Roger Ekuh',
  'team.roger.position': 'Président et PDG',
  'team.roger.bio': 'Leader expérimenté avec un bilan éprouvé en technologie financière et développement commercial mondial.',
  
  'team.eveline.name': 'Dr. Eveline Ibeagha',
  'team.eveline.position': 'Finance et Administration',
  'team.eveline.bio': 'Experte en gestion financière et opérations administratives avec une vaste expérience en banque internationale.',
  
  'team.hasan.name': 'Hasan Kayar',
  'team.hasan.position': 'Technologie',
  'team.hasan.bio': 'Innovateur technologique spécialisé dans les solutions fintech et les stratégies de transformation numérique.',
  
  'team.edmond.name': 'Edmond Mbong',
  'team.edmond.position': 'Affaires corporatives',
  'team.edmond.bio': 'Leader stratégique en communications corporatives et relations avec les parties prenantes avec une expertise mondiale.',
};
